import { createRootRoute, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import AuthWrapper from '../../components/AuthWrapper'
import { Toaster } from '../../components/ui/sonner'
import { CommandMenu } from '../../components/CommandMenu'
import { InvoiceCommands } from '../../components/commands/InvoiceCommands'
import { CommandRegistryProvider } from '../../contexts/CommandRegistryContext'
import { GlobalCommands } from '../../components/GlobalCommands'

export const Route = createRootRoute({
    component: () => (
        <CommandRegistryProvider>
            <AuthWrapper>
                <GlobalCommands />
                <InvoiceCommands />
                <CommandMenu />
                <Outlet />
                <Toaster />

                {import.meta.env.DEV && <TanStackRouterDevtools />}
            </AuthWrapper>
        </CommandRegistryProvider>
    ),
})
